import { useQuery } from "react-query";
import { getOfficeHierarchy } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetOfficeHierarchy = () => {
  return useQuery(["GetOfficeHierarchyReport"], getOfficeHierarchy, {
    refetchOnWindowFocus: false,
  });
};
export default useGetOfficeHierarchy;
